import { useEffect, useState, useContext } from 'react';
import SubmitButton from '../AuthPages/SubmitButton';
import styles from './FundingFilters.module.css';
import { Context } from '../../AuthContext';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner';
import FundingFilters from '../../utils/FundingFilters';

const FundingFiltersPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({});
  const { user, authLoading } = useContext(Context);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const submitForm = async () => {
    try {
      const token = await user.getIdToken();
      const response = await fetch(
        process.env.REACT_APP_FLASK_WEBSERVER + 'edit_user',
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ funding_filters: formData }),
        }
      );
      if (response.status === 200) {
        toast.success('Funding filters have been updated successfully!');
      }
    } catch (error) {
      console.error('something happened wrong:', error);
    }
  };

  const fetchFundingFilters = async () => {
    const token = await user.getIdToken();
    const url = process.env.REACT_APP_FLASK_WEBSERVER + 'get_user_funding_filters';
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const userDetails = await res.json();
    return userDetails;
  };

  useEffect(() => {
    document.title = 'Funding Filters - The Simple Platform';

    if (authLoading) return;

    (async () => {
      if (user) {
        const db = await fetchFundingFilters();
        setFormData(db || {});
        setIsLoading(false);
      }
    })();
  }, [authLoading, user]);

  return isLoading ? (
    <Spinner />
  ) : (
    <div className={styles.page_without_margin}>
      <div className={styles.page_container}>
        <div className={styles.wrapper}>
          <h2 className={styles.title}>Funding Filters</h2>
          <div className={styles.pb_100}>
            {FundingFilters.map((item, key) => (
              <div key={key}>
                <p className={styles.groupTitle}>{item.heading}</p>
                {item.fields.map((field) => (
                  <div className={styles.widthFull} key={field.key}>
                    <label className={styles.label}>{field.label}</label>
                    {field.type === 'select' ? (
                      <select
                        className="input-style w-full"
                        defaultValue={
                          formData[field.key]?.includes(',') ? 'All' : formData[field.key] || ''
                        }
                        onChange={(e) => {
                          const val =
                            e.target.value === 'All'
                              ? field.options.filter((option) => option !== 'All').join(', ')
                              : e.target.value;
                          handleChange(field.key, val);
                        }}
                      >
                        <option value="" disabled>
                          Select a {field.label}
                        </option>
                        {field.options.map((option, index) => (
                          <option key={index}>{option}</option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type="text"
                        className="input-style w-full"
                        key={field.key}
                        value={formData[field.key] || ''}
                        onChange={(e) => handleChange(field.key, e.target.value)}
                        placeholder={field.placeholder || ''}
                        maxLength={field.maxlength || undefined}
                      />
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.footer}>
          <div style={{ width: '75vw' }}>
            <div className={styles.wrapper}>
              <SubmitButton text={'Save Changes'} onClick={submitForm} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundingFiltersPage;
